import classes from "./CompareNow.module.css";
import Compare from "../../TransportComparison/Layout";
import Modal from "../../Shared/PopupModal/PopupModal";
import {
  useAppContext,
  ContextConstants,
} from "../../UserContext/TransporterCompareContext";

const CompareNow = (props) => {
  const { dispatch, currentList = [] } = useAppContext();

  const DisplayTransporters = ({ transporter }) => {
    return <></>;
  };

  const removeFromList = (id) => {
    dispatch({
      type: ContextConstants.removeTransporterFromList,
      payload: currentList.filter((item) => item.transporter_id !== id),
    });
  };

  const Title = () => {
    return (
      <span className={`${classes["s-cn"]}`}>
        <b>Compare</b>Now
      </span>
    );
  };

  return currentList.length > 0 ? (
    <div className={`${classes["compare_now_div"]} shadow`}>
      {currentList.map((transporter, index) => (
        <div
          className={`${classes["s-compare-transporter"]}`}
          key={`transporter${index}`}
        >
          <div className={`${classes["s-compare"]}`}>
            <DisplayTransporters transporter={transporter} />
          </div>
          <div className={classes["main_card"]}>
            <div className={`${classes["s-main-card"]}`}>
              <button
                className={"close"}
                type="button"
                aria-label="Close"
                onClick={(e) => removeFromList(transporter.transporter_id)}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div>
              <h5 className={classes["title"]}>
                {transporter.transporter_name.toUpperCase()}
              </h5>
            </div>
          </div>
        </div>
      ))}
      <Modal
        buttonLabel={"CompareNow"}
        content={<Compare />}
        id={"Compare_Modal"}
        className={"CompareNowModalBox"}
        title={<Title />}
        buttonClass={"btn btn-success btn-sm"}
        style={{ height: "fit-content", fontSize: "medium", marginTop: "1%" }}
        overflowStyles={{ overflow: "hidden" }}
        size="fullscreen"
      />
    </div>
  ) : null;
};

export default CompareNow;
